<template>
    <div class="print-well-annotated-event-table">
        <div class="annotated-header">{{ $translate('annotated_events') }}</div>
        <table class="annotated-table">
            <thead>
                <tr>
                    <th>{{ $translate('event') }}</th>
                    <th>{{ $translate('at_hour') }}</th>
                    <th>{{ $translate('delta_hours') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="event in focusedWell.inferenceData.morphokinetics">
                    <td>
                        <span class="event-label">
                            {{ $translate(event.systemName) }}
                        </span>
                    </td>
                    <td>
                        <span class="range-metric-value">
                            {{ $uiUtils.formatNumber(event.value, 1) }}
                        </span>
                    </td>
                    <td>
                        <span class="range-metric-delta" :class="deltaColor(event)">
                            {{ $uiUtils.formatNumber(event.delta, 0) }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'PrintWellAnnotatedEventTable',
    computed: {
        ...mapGetters({
            tenant: 'common/getTenant',
            avatarUrl: 'common/getAvatarUrl'
        }),
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            user: state => state.common.user
        })
    },
    methods: {
        deltaColor(event) {
            if (!event.range) {
                console.error('NO RANGE', event)
                return
            }

            return this.$uiUtils.getColoredRangeMetricColor(event)
        }
    }
}
</script>
<style lang="scss" scoped>
.print-well-annotated-event-table {
    .annotated-header {
        font-weight: bold;
        color: $black;
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .annotated-table {
        width: 100%;

        thead > tr {
            border-bottom: 1px solid $light-alpha;

            th {
                padding-bottom: 10px;
                font-weight: normal;
            }
        }
        tbody > tr td {
            padding-top: 10px;
        }

        .range-metric-delta {
            position: relative;

            &::before {
                content: '';
                display: block;
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                background-color: $dark-4;
                position: absolute;
                top: 3px;
                left: -0.9rem;
            }
            &.red::before {
                background-color: $red;
            }
            &.amber::before {
                background-color: $orange;
            }
            &.green::before {
                background-color: $green;
            }
        }
    }
}
</style>